"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _sharedComponents = require("@site/shared-components");
const AvailableCardSkeletonLoader = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ux-card mb-0 available-card-skeleton-loader",
    "data-testid": "available-card-skeleton-loader"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: "20%",
    height: "1.5rem"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "mt-4",
    width: "60%",
    height: "2.5rem"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "mt-5",
    width: "20%",
    height: "1.5rem"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "mt-3",
    width: "25%",
    height: "1.5rem"
  })), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: "30%",
    height: "2.5rem"
  }));
};
var _default = exports.default = AvailableCardSkeletonLoader;